import { get } from 'lodash/fp';

import * as fromReducer from './reducer';

const getCountriesFromReducer = get('territories.countries');

export const getIsLoading = state => fromReducer.getIsLoading(getCountriesFromReducer(state));

export const getCountries = state => fromReducer.getCountries(getCountriesFromReducer(state));
